import { MuiTelInput, type MuiTelInputProps } from "mui-tel-input";
import type { FC } from "react";

const MUITelInput: FC<MuiTelInputProps> = ({ ...props }) => (
	<MuiTelInput
		langOfCountryName="no"
		defaultCountry="NO"
		preferredCountries={["NO"]}
		{...props}
	/>
);

export default MUITelInput;
